import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

import { combineLatest, map, Observable } from 'rxjs'

import { KayttajaService } from './_angular/service/kayttaja.service'

@Component({
  selector: 'lemon-dialog-header',
  templateUrl: './lemon-dialog-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LemonDialogHeader {
  @Input()
  naytaSuljeRuksi = true

  @Input()
  naytaOtsikko = true

  // Tosi kun työntekijä impersonoi loppukäyttäjää. Pakottaa sulje-ruksin näkyviin myös niissä dialogeissa
  // joissa on naytaSuljeRuksi=false, jotta impersonoija pääsee aina pois pakottavista dialogeista.
  kayttajaaImpersonoidaanObservable: Observable<boolean>

  constructor(private _kayttajaService: KayttajaService) {
    this.kayttajaaImpersonoidaanObservable = combineLatest([this._kayttajaService.kayttajanTiedotObservable, this._kayttajaService.kayttajaaImpersonoidaanObservable]).pipe(
      map(([kayttaja, impersonoidaan]) => !!kayttaja && impersonoidaan),
    )
  }
}
